// Plus Jakarta Sans, used by the Restaurant Profile page and the side nav.
// The font is loaded in public/index.html.
//
// The app theme gives every typography variant its own fontFamily (Inter), so
// changing the top-level fontFamily alone would not reach them; each variant
// gets the family set separately.
import { createTheme } from '@mui/material/styles'

export const JAKARTA = '"Plus Jakarta Sans", system-ui, sans-serif'

const TYPE_VARIANTS = [
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2',
  'body1', 'body2', 'button', 'caption', 'overline'
]

export const typographyWithFont = (outer, fontFamily) => {
  const typography = { ...outer.typography, fontFamily }
  TYPE_VARIANTS.forEach(k => {
    typography[k] = { ...(outer.typography[k] || {}), fontFamily }
  })
  return typography
}

// For a nested ThemeProvider: swaps the font family and changes nothing else.
// Reaches portaled children (tooltips, menus) through React context.
export const jakartaFontTheme = outer => createTheme({
  ...outer,
  typography: typographyWithFont(outer, JAKARTA)
})
